export default {
    messages: {},
    inbox: {},
    messageMeta: {},
    loadingMessages: false
}
